import React, { FC, useState } from 'react'
import { connect } from 'react-redux'
import { setCommonConfig } from '@/store/actions/index'
import { Form, Button, Input, Col, Row, message } from 'antd'
import EditorModal from './editorModal'
import api from '@/services/lego'
import utils from '@/utils/utils'
const domain = 'https://baleen-cdn-g.bybieyang.com/'
interface BlockConfigProps {
  id: string
  config: {
    href: string
    contextUrl: string
    link?: string
    deepLink?: string
  }
  editConfig(id: string, name: string, value: any): void
}

const layout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 16 },
}

const BlockConfig: FC<BlockConfigProps> = ({ config, editConfig, id }) => {
  const [form] = Form.useForm()
  const { contextUrl, link, deepLink } = config
  const [visible, setVisible] = useState(false)

  const onValuesChange = (data: Record<string, any>) => {
    if (!data) {
      return
    }
    const [key, value] = Object.entries(data)[0]
    editConfig(id, key, value)
  }

  const onCancel = () => setVisible(false)

  const onChange = (svgString, json) => {
    const uId = utils.generateImgName()
    const file = new File([svgString], `${utils.generateImgName()}.svg`, { type: 'image/svg+xml' })
    const svgData = {
      content: file,
      format: 'svg',
      path: `${uId}.svg`,
    }
    const contentData = {
      content: json,
      path: `content/${uId}.json`,
      bucket: 'baleen',
    }

    Promise.all([uploadSvg(svgData), uploadJSON(contentData)])
      .then(res => {
        const svgHref = `${domain}${res[0].data.name}`
        const contentUrl = `https://baleen-cdn-g.bybieyang.com/lego/${contentData.path}`
        editConfig(id, 'href', svgHref)
        editConfig(id, 'contextUrl', contentUrl)
        onCancel()
      })
      .catch(() => {
        message.error('error')
      })
  }

  const uploadSvg = (data: Record<string, any>) => {
    const formData = new FormData()
    Object.entries(data).forEach(([key, value]) => {
      formData.append(key, value)
    })
    return api.uploadImg(formData)
  }

  const uploadJSON = data => {
    return api.uploadJson(data)
  }

  const onShow = () => setVisible(true)

  return (
    <>
      <Form
        initialValues={{ link, deepLink }}
        {...layout}
        form={form}
        onValuesChange={onValuesChange}
      >
        <Form.Item label="link" name="link">
          <Input placeholder="link" />
        </Form.Item>
        <Form.Item label="deepLink" name="deepLink">
          <Input placeholder="deepLink" />
        </Form.Item>
        <Row>
          <Col offset={4}>
            <Button type="primary" onClick={onShow}>
              编辑
            </Button>
          </Col>
        </Row>
      </Form>
      <EditorModal
        contentUrl={contextUrl}
        visible={visible}
        onCancel={onCancel}
        onChange={onChange}
      />
    </>
  )
}

const mapDispatchToProps = dispatch => ({
  editConfig: (id, name, value) => {
    dispatch(setCommonConfig(id, name, value))
  },
})

export default connect(null, mapDispatchToProps)(BlockConfig)
